<template>
    <div class="d-flex tag-input align-center flex-wrap">
        <di v-if="!tool">
            <v-chip
                @click:close="removeTag(index)"
                v-for="(tag, index) in tags"
                :key="index"
                close
                class=""
            >
                {{ tag }}
            </v-chip>

            <v-text-field
                @keydown.enter="addTag"
                @keydown.space="addTag"
                @keydown.delete="removeLastTag"
                dense
                solo
                hide-details
                v-model="tag"
                flat
                label="Enter a Tag"
            >
            </v-text-field>
        </di>
        <v-select
            v-if="tool"
            v-model="tags"
            :items="tagsToSelect"
            multiple
            chips
            deletable-chips
            hide-details
            label="Select Tags"
            @input="changeTags"
        />
    </div>
</template>
<script>
import API from '@/services/api'

export default {
    name: 'tagInput',
    props: {
        image: Object,
        value: Boolean,
        tool: {
            type: Object,
            default() {
                return undefined
            },
        },
    },
    data() {
        return {
            tags: [],
            tag: '',
            rules: {
                required: v => !!v || 'Required',
                value: v => !v || v.size > 0 || 'Required',
            },
            tagsToSelect: [],
        }
    },
    watch: {
        value: function() {
            this.tags = []
            this.image.tags = this.tags
        },
    },
    async mounted() {
        try {
            this.loading = true
            this.tagsToSelect = await API.getToolTags()
        } catch (error) {
            this.setErrorItem({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    methods: {
        addTag(event) {
            event.preventDefault()
            var val = event.target.value.trim().toLowerCase()
            if (val.length > 0) {
                this.tags.push(val)
                event.target.value = ''
                this.tag = ''
            }
            this.image.tags = this.tags
        },
        changeTags() {
            this.image.tags = this.tags
        },
        removeTag(index) {
            this.tags.splice(index, 1)
        },
        removeLastTag(event) {
            if (event.target.value.length === 0) {
                this.removeTag(this.tags.length - 1)
            }
        },
    },
}
</script>
<style scoped>
.tag-input {
    width: 100%;
    border-bottom: 1px solid gray;
    font-size: 0.9em;

    box-sizing: border-box;
    padding: 0 5px;
}

.tag-input__tag {
    height: 30px;
    margin-right: 5px;
    float: left;
    background-color: #eee;
    line-height: 30px;
    padding-right: 5px;
    border-radius: 5px;
}

.tag-input__text {
    border: none;
    outline: none;
    font-size: 0.9em;
    line-height: 50px;
    background: none;
}
</style>
